// 테넌트별 UI 기능 노출 토글. 빌드 env VUE_APP_TENANT 로 선택.
// - tenantBranding.js / kogasSignup.js 와 동일한 테넌트 토글 패턴(vue-cli-service build --mode kogas).
// - 기본은 "노출(true)". HIDDEN 에 등록된 테넌트+키만 숨긴다 → 미등록 테넌트(IDC 등)는 영향 0.
// - 사용: 템플릿에서 v-if="$feat('zoneFileUpload')" (v-show 아님 — DOM 자체 제거).
//
// ⚠️ UI 숨김 ≠ 서버 차단. 관련 엔드포인트(예: /ArSpaceFile)는 여전히 열려 있으므로,
//    완전 차단이 필요하면 서버측 가드를 별도로 둔다.

const TENANT = process.env.VUE_APP_TENANT || "default";

// 테넌트별 "숨길" 기능 키 목록.
const HIDDEN = {
  kogas: [
    "zoneFileUpload", // 협업 Zone 채팅 하단 파일 업로드 버튼
    "profileLicense", // Header 프로필 팝업의 라이선스 표시
  ],
};

const hiddenSet = new Set(HIDDEN[TENANT] || []);

// feat(key): 해당 기능을 노출할지 여부. 기본 true, 숨김 목록에 있으면 false.
export function feat(key) {
  return !hiddenSet.has(key);
}
